<div class="landingpage-container" *ngIf="showLandingContainer">
  <div>
    <img id="merge-icon" src="assets/images/Group 6846.png" alt="merge-icon">
  </div>
  <div class="header">{{cfetLabels.utf_auth_page.header}}</div>
  <p>{{cfetLabels.utf_auth_page.content1}}</p>

  <div id="use_org_link" *ngIf="showLandingPage">
    <p class="p2" [innerHTML]="cfetLabels.utf_auth_page.content2"></p>
    <a tabindex="0" (click)="showAffiliationPage($event)"
      (keyup)="showAffiliationPage($event)">{{cfetLabels.utf_auth_page.link}}</a>
  </div>

  <div class="form-group" *ngIf="showAffiliationCodePage">
    <form [formGroup]="affiliationCodeForm">
      <p class="p2" [innerHTML]="cfetLabels.utf_auth_page.content3"></p>
      <div class="row no-gutters form-row" id="affiliation-code-input" [class.error]="!isValidAffCode">
        <div class="col-md-12">
          <label for="affiliationCode" id="enter_code">{{cfetLabels.utf_auth_page.enter_code}}</label>
          <div class="affiliation-code-inputbox">
            <input class="form-control" id="affiliation" formControlName="affiliationCode" tabindex="0" type="text"
              (blur)="checkAffCode()" autocomplete="off" maxlength="256">
            <div *ngIf="!isValidAffCode" role="alert" [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : (!isValidAffCode)}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="!isValidAffCode">{{cfetMessages.affiliation_code_error}}</span>
            </div>
          </div>
        </div>
      </div>
      <div id="no_code_link">
        <a tabindex="0" (click)="hideAffiliationPage($event)"
          (keyup)="hideAffiliationPage($event)">{{cfetLabels.utf_auth_page.no_code_link}}</a>
      </div>
    </form>
  </div>

  <hr>

  <div class="col-12" class="btn-container">
    <a tabindex="0"  type="button" id="cancel_link" class="utf-cancel-link"
      (click)="cancelApplication($event)" (keyup)="cancelApplication($event)">
      <em aria-label=""></em>
      {{cfetButtonLabels.button_labels.cancel}}</a>
    
    <button *ngIf="!showAffiliationCodePage" tabindex="0" type="button" id="btn-submit" class="utf-button-blue"
      (click)="getStart($event)" (keyup)="getStart($event)">
      {{cfetButtonLabels.button_labels.getStarted}}</button>
    <button *ngIf="showAffiliationCodePage" type="button" id="btn-submit" (click)="submit($event)"
      class="utf-button-blue" (keyup)="submit($event)" tabindex="0" [disabled]="disabledSubmitButton"><em
        aria-label=""></em>
      {{cfetButtonLabels.button_labels.submit}}</button>
  </div>
</div>
<app-utf-sync-details-page *ngIf="showLoading"></app-utf-sync-details-page>